/**
 * Guide topic — Ordering comms. Walks through how an order's lifecycle
 * events turn into (or are suppressed from becoming) a customer email.
 */

import { GuidePage } from "@/features/guide/guide-page";

export function GuideOrderingPage() {
  return (
    <GuidePage
      eyebrow="Workflow"
      title="Ordering comms"
      intro="Every order moves through a six-step lifecycle, with backorders as a separate exception lane. Each step is an event the agent can act on: email the customer, or suppress the email and log why."
      cta={{ to: "/ordering", label: "Open ordering comms" }}
      walkthrough={[
        {
          step: "An order advances through its lifecycle",
          body: "Placed, confirmed, shipped, and so on — each transition fires an event, or the order drops into the backorder lane if stock runs out.",
        },
        {
          step: "The agent decides: email or suppress",
          body: "Customer notification preferences and any account exclusions (key/EDI accounts are never messaged) determine whether the event becomes a sent email or a logged suppression.",
        },
        {
          step: "The customer is emailed, or the suppression is recorded",
          body: "A sent email is written to the account's audit log with who it went to and when; a suppression records the reason instead — nothing is silently dropped.",
        },
        {
          step: "A rep reviews the per-order email log",
          body: "Every order detail page shows the full lifecycle stepper alongside its sent-email history, so a rep can see exactly what was communicated and when.",
        },
      ]}
    />
  );
}
